import React, { Component } from "react";
import { connect } from "react-redux";
import Box from "grommet/components/Box";
import Button from "grommet/components/Button";
import Select from "grommet/components/Select";
import Layer from 'grommet/components/Layer';
import TableRow from 'grommet/components/TableRow';
import LoadFiles from './LoadFiles';
import Table from 'grommet/components/Table';
import queryString from 'query-string'
import Spinning from 'grommet/components/icons/Spinning';
import Heading from 'grommet/components/Heading';
import CloseIcon from 'grommet/components/icons/base/Close';
import Paragraph from 'grommet/components/Paragraph';
import WarningIcon from 'grommet/components/icons/base/Alert';
import Revert from 'grommet/components/icons/base/Revert';
import Animate from 'grommet/components/Animate';
import { said } from '../../AppConfig';
import * as commonConstants from '../../State/constants/CommonConstants';
import { comparedata,fetchCompareSolution,loadSessionfromSSET,exportCompareSolution  } from '../../State/actions/sessions';
import { _said } from '../../SizerUI/SizerConfig/Config.js';
let compareSolution1Options = ["Growth - 1Y", "Growth - 2Y", "Growth - 3Y"];
let compareSolution2Options =[];
let compareSolution1value = compareSolution1Options[0];
let compareSolution2value = "Growth - 2Y";
var Com = '';
let data = [];
var compare = ''
var SavedSolutionname = '';
var CombineRackSecond = []
let SolutionAlternativeTabsContent;
let RolesList = [];
let getSSETData = false;
let EPAId = 'EPAvNext';
const BLUE_DATA = "BlueData";
const GROWTH_4Y = "Growth - 4Y";
var totalNumOfRows = [];
let CombineRack = [];
var CombineRackSecond = []
var ComputeNodeArray = [];
var ComputeNodeSecondSolArray = [];
var totalNumOfRows = [];
//let RolesList = [];

class CompareSol extends Component{
    constructor() {
        super();
        this.state = {
          showSaveSolution: false, showDupSoLPopup: false, SessionName: '', CurrentSession: {},
          SolutionObj: '', RoleObj: '', RoleItems: '', SharedRoleObj: '', SharedRoleItems: '',
          activeTab: 0, ServQty: 0, HomePageJson: [], AdditionalInfoPop: false,
          GRPresent: false, GRPresentStatic: false, MetricsDataPresent: false,
          ActiveSoln: null, ActiveSolTabClass: '', RackItem: '', showDelSession:true,
          activeSoltab: 0, ComapareSolState: false, compareSolutionTabactive: false, CloseErrorLayer: false,
          flag: false,header1:'',dropDownState:false
    
        }
        this.compareSolnMethod = this.compareSolnMethod.bind(this);
    }
    componentDidMount() {
        //   this.props.onFetchCompareMetricsData({'SessionID': this.props.activeSession.id});
        if(!this.props.activeSession  ||  this.props.activeSession.SavedSolname=='') {
          if (this.props.externalAppProps && this.props.isFromExternalApp) {
            getSSETData = true;
            let queryParameter = queryString.parse(window.location.search);
            let sessionObject = { "SessionID": queryParameter.sizerReference };
            let userData = {
              "reference": queryParameter.reference,
              "isSizerAsEntry": queryParameter.isSizerAsEntry ? true : false,
              "isCompare":true
            };
            if (getSSETData) {
              getSSETData = false;
              this.props.getSSETData(userData);
            }

            //this.props.onFetchCompareSolution(sessionObject);
          }
        }
    
      }
      componentWillReceiveProps(nextProps) {
            
        if (nextProps.activeSession && nextProps.activeSession.workload) {
            let obj = "";
            let queryParameter = queryString.parse(window.location.search);
            nextProps.activeSession.id= queryParameter.sizerReference ;
            if (said === 'CS750VirtSizer' ||  said === 'SynergySizer') {
              obj = {
                "Workload": nextProps.activeSession.workload
              }
            }
            else {
              obj = nextProps.activeSession.workload;
            }
            //if(nextProps.activeSession.workload.UserInputs.SizerMode!== commonConstants.GPELEMENT)
            //this.props.onNewSession(obj);
        }
    }
    compareSolution12Change = (e) => {
        if(e.target.name === "compareSolution1") {
          compareSolution1value = e.option;
        }
        else if (e.target.name === "compareSolution2") {
          compareSolution2value = e.option;
          if (e.option === "Browse") {
            this.compareSolnMethod(e,true)
          }
        }
        this.setState({dropDownState:true});
      }
      compareSolnMethod = (e,isfromBrowse) => {
        this.setState({ComapareSolState:true});
        if (this.props.activeSession.EPAArray.length > 0 && !isfromBrowse) {
        let value;
         if(this.props.activeSession.SavedSolname && this.props.activeSession.SavedSolname.SavedSol === compareSolution2value){
          value = {
            "SessionID": this.props.activeSession.id,
            "SessionIDsaved": this.props.activeSession.SavedSolname.savedId,
            "EPASolutionType" : compareSolution1value.split('-')[1].trim()[0]
          };
         } 
          else {
          let solutionType = compareSolution1value.split('-')[1].trim()[0];
          solutionType += ':'
          solutionType += compareSolution2value.split('-')[1].trim()[0];      
          value = {
            "SessionID": this.props.activeSession.id,
            "EPASolutionType": solutionType
          }
          //this.SaveSolname(compareSolution2value);
        }    
        this.props.OnComparedata(value);
    
        } else {
          this.state.flag = true;
          compareSolution2value = 'Growth - 1Y';
          Com = <Layer margin="none" pad="small" style={{ width: '100% !important', zIndex: '500 !important' }}>
              <LoadFiles title={"Solution"} onClose={this.handleClose} flag={this.state.flag} Savedname={this.SaveSolname.bind(this)} solutionIndex={isfromBrowse ? compareSolution1value.split('-')[1].trim()[0] : null} />
            </Layer>
    
        }
    
        this.props.activeSession.selectedTitles = {
          compareSolution1value,
          compareSolution2value
        }
        this.setState({ header1: compareSolution1value , dropDownState:false });
      }
      handleClose = () => {
        Com = ''
        this.setState({ flag: false })
      }
      SaveSolname = (value,id) => {
        SavedSolutionname = value;
        let compareSolutionObj = {
          SavedSolutionName:value,
          selectedselection:id
        };
        this.props.SavedSolname(compareSolutionObj)
        compareSolution2value = value;
        this.props.activeSession.selectedTitles.compareSolution2value = value;
      }
      onExport() {
        let text = {
          Data: {
            input: {
              "content": data,
              "currencyone": '$ ' + this.props.comparedata.CompareData.Solution[1].SolPrice,
              "currencytwo": '$ ' + this.props.comparedata.CompareData.Solution[0].SolPrice,
              //"Solution1": this.props.activeSession.alias,
              "Solution1": this.props.activeSession.selectedTitles.compareSolution1value,
              "Solution2": this.props.activeSession.selectedTitles.compareSolution2value,
              "Rack1": this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"],
              "Rack2": this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"]
            }
          }
        }
        //let jsontext=JSON.stringify(text)
        //dumm.push(text)
        this.props.onExportCompaeSolution(text)
    
      }

      populateStorageVolumes = (tableData) => {
        let StorageVolume = []
        let strVolume = ""
        tableData.map((Volume) => {
          StorageVolume.push(
            Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
          )
        })
        StorageVolume.map((disk, id)=>{
          if( id === StorageVolume.length-1) { 
            strVolume += disk;
          } else {
            strVolume += disk + "   "; 
          }
        })
        return strVolume;
      }

      redirectUrl() {
        console.log('redirecting to SSET');
        window.location.replace(this.props.externalAppProps.ssetUrl);
    }

  render() {
    compare = ''
    var Currencyone = ''
    var Currencytwo = ''
    //compareSolution1Options = ["Growth - 1Y", "Growth - 2Y", "Growth - 3Y"];
    //compareSolution2Options = compareSolution1Options;

    if(!this.props.sessions.isLoading && this.props.activeSession!=='' && this.props.activeSession.EPAArray!==undefined){
      
      if(this.props.activeSession.EPAArray.length > 0 && !this.state.dropDownState){
    if(this.props.activeSession.selectedTitles)
      {
        compareSolution1value = this.props.activeSession.selectedTitles.compareSolution1value;
        compareSolution2value = this.props.activeSession.selectedTitles.compareSolution2value;
      }
    }
    if(this.props.activeSession.SavedSolname && this.props.activeSession.SavedSolname.savedId)
    {
    compareSolution2Options = compareSolution2Options.concat(this.props.activeSession.SavedSolname.SavedSol);
    }
    if (said === EPAId && this.props.activeSession.workload.UserInputs!==undefined && this.props.activeSession.workload.UserInputs.Environments.WorkloadType === BLUE_DATA) {
      if (compareSolution1Options.indexOf(GROWTH_4Y) === -1) {
        compareSolution1Options.push(GROWTH_4Y);
      }
    }
    compareSolution2Options = compareSolution1Options.concat([]);
    compareSolution2Options.splice(compareSolution2Options.indexOf(compareSolution1value),1)
    compareSolution2value = compareSolution2Options.indexOf(compareSolution2value) !== -1 ?compareSolution2value : compareSolution2Options[0];
  }
    if(this.props.activeSession && this.props.activeSession.EPAArray && this.props.activeSession.EPAArray.length > 0){
      if (this.props.comparedata !== null && this.props.comparedata !== undefined && (this.props.comparedata.CompareData === 'File Mismatch' || this.props.comparedata.CompareData === 'Different Pricing Region')) {
    if (this.props.comparedata.CompareData['@Currency'] === 'UD') {
      Currencyone = '$ ' + this.props.comparedata.CompareData.Solution[1].SolPrice
      Currencytwo = '$ ' + this.props.comparedata.CompareData.Solution[0].SolPrice

    } else {
      Currencyone = this.props.comparedata.CompareData['@Currency'] + " " + this.props.comparedata.CompareData.Solution[1].SolPrice
      Currencytwo = this.props.comparedata.CompareData['@Currency'] + " " + this.props.comparedata.CompareData.Solution[0].SolPrice
    }
  }     
        var StyleTable = "CompareTable"
        
        var backgrdclrtotal = '#fff'
        if (Currencyone !== Currencytwo && Currencyone !== 'NA' && Currencytwo !== 'NA') {
          backgrdclrtotal = '#ffd144'
          
        }
        else{
          backgrdclrtotal = '#fff'
        }
        if (_said === 'EPAvNext') {
          if (this.props.comparedata !== null && this.props.comparedata !== undefined && (this.props.comparedata.CompareData === 'File Mismatch' || this.props.comparedata.CompareData === 'Different Pricing Region')) {
            this.state.CloseErrorLayer = false
          }
          if (this.props.comparedata !== undefined && this.props.comparedata !== null && this.props.comparedata.CompareData !== null && this.props.comparedata.CompareData !== 'File Mismatch' && this.props.comparedata.CompareData !== 'Different Pricing Region') {
            var FirstSolRoles = [];
            var ExtraSeconSolroles = [];
            ComputeNodeArray = [];
            ComputeNodeSecondSolArray = [];
            CombineRack = [];
            CombineRackSecond = [];
            ComputeNodeArray = [];
            ComputeNodeSecondSolArray = [];
            totalNumOfRows = [];
            RolesList = [];
            data = [];
            //dumm = []
            var Type = this.props.workload.UserInputs.Environments.WorkloadType;
            console.log(this.props.comparedata)
            let backgrdclrrack = 'none'
            if (this.props.comparedata.CompareData.Solution[0].RackSelected["@CompDesc"] !== this.props.comparedata.CompareData.Solution[1].RackSelected["@CompDesc"]) {
              backgrdclrrack = '#ffd144'
            }
            else{
              backgrdclrrack = '#fff'
            }
            CombineRack = this.props.comparedata.CompareData.Solution.map(function (val) {
              if (val.RackSelected !== undefined) {
                return <td style={{ backgroundColor: backgrdclrrack }}>{val.RackSelected["@CompDesc"]}</td>
              }
            });
            CombineRackSecond = CombineRack.reverse()
            if (Array.isArray(this.props.comparedata.CompareData.Solution[0].Roles.Role)) {
              this.props.comparedata.CompareData.Solution[0].Roles.Role.map(function (val) {
                let strVolume;
                if (val["RoleName"] === "Compute hosts" || val["RoleName"] === "Compute Node") {
                  val["RoleName"] = "Compute Hosts"
                } else if (val["RoleName"].toLowerCase() === "compute hosts with gpus" || val["RoleName"] === "GPU Node") {
                  val["RoleName"] = "Compute Hosts With GPUs"
                } else if (val["RoleName"] === "Gateway Node") {
                  val["RoleName"] = "Gateway Host"
                } else if (val["RoleName"] === "Controller Node") {
                  val["RoleName"] = "Controller Host"
                } else if (val["RoleName"] === "Storage : HDFS and HDFS-EC") {
                  val["RoleName"] = "Storage : HDFS"
                }
                FirstSolRoles.push(val["RoleName"])
                if (Array.isArray(val.DAS.TableData)) {
                  strVolume = this.populateStorageVolumes(val.DAS.TableData)
    
                } else {
                  strVolume = val.DAS.TableData["VolumeName"] + " - " + val.DAS.TableData["DiskQty"] + " X " + val.DAS.TableData["Disk"]
                }
                val["Memory"] = val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
                if (Type === "BlueData") {
                  ComputeNodeArray.push(
                    { "Role Name": val["RoleName"] },
                    { "Server Name": val.ServerName["@Qty"] + " X " + val.ServerName["#text"] },
                    { "Processor": val["ProcessorDetails"] },
                    { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                    // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                    { "Storage": strVolume }
                  );
                } else {
                  let SerName = val.ServerName["@Qty"] + " X " + val.ServerName["#text"]
                   val.Processor=val.Processor.replace("1P"," ")
                  if (val.ServerName["#text"] === "HP Moonshot System") {
                    SerName = val.Processor
                  }
                  ComputeNodeArray.push(
                    { "Role Name": val["RoleName"] },
                    { "Server Name": SerName },
                    { "Processor": val["ProcessorDetails"] },
                    { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                    // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                    { "Storage": strVolume });
                    if(val.CPUPerf !== undefined && val.StorageTP !== undefined && val.StorageReadIO !== undefined && val.StorageWriteIO !== undefined && val.CPUPerfPrice !== undefined
                      && val.RawStoragePrice !== undefined && val.StoragePerfPrice !== undefined && val.CPUPerfWatt !== undefined && val.StoragePerfWatt !== undefined){
                    ComputeNodeArray.push(
                    { "CPU Performance (SPECint)": val.CPUPerf["#text"] },
                    { "Storage Throughput (MB/s)": val.StorageTP["#text"] },
                    { "Storage Read IOPs (IOPs)": val.StorageReadIO["#text"] },
                    { "Storage Write IOPs (IOPs)": val.StorageWriteIO["#text"] },
                    { "CPU Perf/Price (SPECint/$1k)": val.CPUPerfPrice["#text"] },
                    { "Raw Storage capacity/Price (TB/$1k)": val.RawStoragePrice["#text"] },
                    { "Storage Perf/Price (MB/s per $1k)": val.StoragePerfPrice["#text"] },
                    { "CPU Perf/Watt (SPECint/KW)": val.CPUPerfWatt["#text"] },
                    { "Storage Perf/Watt (MB/s per KW)": val.StoragePerfWatt["#text"] }
    
                  );
                    }
                    else{
                      ComputeNodeSecondSolArray.push(
                        { "CPU Performance (SPECint)": "NA" },
                        { "Storage Throughput (MB/s)": "NA" },
                        { "Storage Read IOPs (IOPs)": "NA" },
                        { "Storage Write IOPs (IOPs)": "NA" },
                        { "CPU Perf/Price (SPECint/$1k)": "NA" },
                        { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                        { "Storage Perf/Price (MB/s per $1k)": "NA" },
                        { "CPU Perf/Watt (SPECint/KW)": "NA" },
                        { "Storage Perf/Watt (MB/s per KW)": "NA" }
    
                      );
                    }
                }
    
              }.bind(this));
            } else {
              var roleobj = this.props.comparedata.CompareData.Solution[0].Roles.Role
              let StorageVolume = [];
              let strVolume;
              if (roleobj["RoleName"] === "Compute hosts" || roleobj["RoleName"] === "Compute Node") {
                roleobj["RoleName"] = "Compute Hosts"
              } else if (roleobj["RoleName"].toLowerCase() === "compute hosts with gpus" || roleobj["RoleName"] === "GPU Node") {
                roleobj["RoleName"] = "Compute Hosts With GPUs"
              } else if (roleobj["RoleName"] === "Gateway Node") {
                roleobj["RoleName"] = "Gateway Host"
              } else if (roleobj["RoleName"] === "Controller Node") {
                roleobj["RoleName"] = "Controller Host"
              } else if (roleobj["RoleName"] === "Storage : HDFS and HDFS-ECC") {
                roleobj["RoleName"] = "Storage : HDFS"
              }
              FirstSolRoles.push(roleobj["RoleName"])
              if (Array.isArray(roleobj.DAS.TableData)) {
                roleobj.DAS.TableData.map((Volume) => {
                  StorageVolume.push(
                    Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
                  )
                })
                if (StorageVolume[2] !== undefined) {
                  strVolume = StorageVolume[0] + "    " + StorageVolume[1] + "    " + StorageVolume[2]
                } else {
                  strVolume = StorageVolume[0] + "    " + StorageVolume[1]
                }
    
              } else {
                strVolume = roleobj.DAS.TableData["VolumeName"] + " - " + roleobj.DAS.TableData["DiskQty"] + " X " + roleobj.DAS.TableData["Disk"]
              }
              roleobj["Memory"] = roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
              if (Type === "BlueData") {
                ComputeNodeArray.push(
                  { "Role Name": roleobj["RoleName"] },
                  { "Server Name": roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"] },
                  { "Processor": roleobj["ProcessorDetails"] },
                  { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                  // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                  { "Storage": strVolume }
                );
              } else {
                let SerName = roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"]
                roleobj.Processor=roleobj.Processor.replace("1P"," ")
                if (roleobj.ServerName["#text"] === "HP Moonshot System") {
                  SerName = roleobj.Processor
                }
                ComputeNodeArray.push(
                  { "Role Name": roleobj["RoleName"] },
                  { "Server Name": SerName },
                  { "Processor": roleobj["ProcessorDetails"] },
                  { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                  // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                  { "Storage": strVolume });
                  if(roleobj.CPUPerf !== undefined && roleobj.StorageTP !== undefined && roleobj.StorageReadIO !== undefined && roleobj.StorageWriteIO !== undefined && roleobj.CPUPerfPrice !== undefined
                    && roleobj.RawStoragePrice !== undefined && roleobj.StoragePerfPrice !== undefined && roleobj.CPUPerfWatt !== undefined && roleobj.StoragePerfWatt !== undefined){
                  ComputeNodeArray.push(
                  { "CPU Performance (SPECint)": roleobj.CPUPerf["#text"] },
                  { "Storage Throughput (MB/s)": roleobj.StorageTP["#text"] },
                  { "Storage Read IOPs (IOPs)": roleobj.StorageReadIO["#text"] },
                  { "Storage Write IOPs (IOPs)": roleobj.StorageWriteIO["#text"] },
                  { "CPU Perf/Price (SPECint/$1k)": roleobj.CPUPerfPrice["#text"] },
                  { "Raw Storage capacity/Price (TB/$1k)": roleobj.RawStoragePrice["#text"] },
                  { "Storage Perf/Price (MB/s per $1k)": roleobj.StoragePerfPrice["#text"] },
                  { "CPU Perf/Watt (SPECint/KW)": roleobj.CPUPerfWatt["#text"] },
                  { "Storage Perf/Watt (MB/s per KW)": roleobj.StoragePerfWatt["#text"] }
                );
                  }
                  else{
                    ComputeNodeSecondSolArray.push(
                      { "CPU Performance (SPECint)": "NA" },
                      { "Storage Throughput (MB/s)": "NA" },
                      { "Storage Read IOPs (IOPs)": "NA" },
                      { "Storage Write IOPs (IOPs)": "NA" },
                      { "CPU Perf/Price (SPECint/$1k)": "NA" },
                      { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                      { "Storage Perf/Price (MB/s per $1k)": "NA" },
                      { "CPU Perf/Watt (SPECint/KW)": "NA" },
                      { "Storage Perf/Watt (MB/s per KW)": "NA" }
    
                    );
                  }
              }
            }
    
            var RolnotPrst = false
            FirstSolRoles.filter((rol) => {
              RolnotPrst = false
              if (Array.isArray(this.props.comparedata.CompareData.Solution[1].Roles.Role)) {
                this.props.comparedata.CompareData.Solution[1].Roles.Role.map(function (val) {
                  if (val["RoleName"] === "Compute hosts" || val["RoleName"] === "Compute Node") {
                    val["RoleName"] = "Compute Hosts"
                  } else if (val["RoleName"].toLowerCase() === "compute hosts with gpus" || val["RoleName"] === "GPU Node") {
                    val["RoleName"] = "Compute Hosts With GPUs"
                  } else if (val["RoleName"] === "Gateway Node") {
                    val["RoleName"] = "Gateway Host"
                  } else if (val["RoleName"] === "Controller Node") {
                    val["RoleName"] = "Controller Host"
                  } else if (val["RoleName"] === "Storage : HDFS and HDFS-ECC") {
                    val["RoleName"] = "Storage : HDFS"
                  }
                  if (rol.toLowerCase() === val["RoleName"].toLowerCase()) {
                    RolnotPrst = true
                    let strVolume;
                    if (Array.isArray(val.DAS.TableData)) {
                      strVolume = this.populateStorageVolumes(val.DAS.TableData)
                    } else {
                      strVolume = val.DAS.TableData["VolumeName"] + " - " + val.DAS.TableData["DiskQty"] + " X " + val.DAS.TableData["Disk"]
                    }
                    val["Memory"] = val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
                    if (Type === "BlueData") {
                      ComputeNodeSecondSolArray.push(
                        { "Role Name": val["RoleName"] },
                        { "Server Name": val.ServerName["@Qty"] + " X " + val.ServerName["#text"] },
                        { "Processor": val["ProcessorDetails"] },
                        { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                        // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                        { "Storage": strVolume }
                      );
                    } else {
                      let SerName = val.ServerName["@Qty"] + " X " + val.ServerName["#text"]
                       val.Processor=val.Processor.replace("1P"," ")
                      if (val.ServerName["#text"] === "HP Moonshot System") {
                        SerName = val.Processor
                      }
                      ComputeNodeSecondSolArray.push(
                        { "Role Name": val["RoleName"] },
                        { "Server Name": SerName },
                        { "Processor": val["ProcessorDetails"] },
                        { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                        // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                        { "Storage": strVolume });
                        if(val.CPUPerf !== undefined && val.StorageTP !== undefined && val.StorageReadIO !== undefined && val.StorageWriteIO !== undefined && val.CPUPerfPrice !== undefined
                          && val.RawStoragePrice !== undefined && val.StoragePerfPrice !== undefined && val.CPUPerfWatt !== undefined && val.StoragePerfWatt !== undefined){
                        ComputeNodeSecondSolArray.push(
                        { "CPU Performance (SPECint)": val.CPUPerf["#text"] },
                        { "Storage Throughput (MB/s)": val.StorageTP["#text"] },
                        { "Storage Read IOPs (IOPs)": val.StorageReadIO["#text"] },
                        { "Storage Write IOPs (IOPs)": val.StorageWriteIO["#text"] },
                        { "CPU Perf/Price (SPECint/$1k)": val.CPUPerfPrice["#text"] },
                        { "Raw Storage capacity/Price (TB/$1k)": val.RawStoragePrice["#text"] },
                        { "Storage Perf/Price (MB/s per $1k)": val.StoragePerfPrice["#text"] },
                        { "CPU Perf/Watt (SPECint/KW)": val.CPUPerfWatt["#text"] },
                        { "Storage Perf/Watt (MB/s per KW)": val.StoragePerfWatt["#text"] }
    
                      );
                        }
                        else{
                          ComputeNodeSecondSolArray.push(
                            { "CPU Performance (SPECint)": "NA" },
                            { "Storage Throughput (MB/s)": "NA" },
                            { "Storage Read IOPs (IOPs)": "NA" },
                            { "Storage Write IOPs (IOPs)": "NA" },
                            { "CPU Perf/Price (SPECint/$1k)": "NA" },
                            { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                            { "Storage Perf/Price (MB/s per $1k)": "NA" },
                            { "CPU Perf/Watt (SPECint/KW)": "NA" },
                            { "Storage Perf/Watt (MB/s per KW)": "NA" }
        
                          );
                        }
                    }
                  }
                }.bind(this))
              } else {
                var roleobject = this.props.comparedata.CompareData.Solution[1].Roles.Role
                if (roleobject["RoleName"] === "Compute hosts" || roleobject["RoleName"] === "Compute Node") {
                  roleobject["RoleName"] = "Compute Hosts"
                } else if (roleobject["RoleName"].toLowerCase() === "compute hosts with gpus" || roleobject["RoleName"] === "GPU Node") {
                  roleobject["RoleName"] = "Compute Hosts With GPUs"
                } else if (roleobject["RoleName"] === "Gateway Node") {
                  roleobject["RoleName"] = "Gateway Host"
                } else if (roleobject["RoleName"] === "Controller Node") {
                  roleobject["RoleName"] = "Controller Host"
                }
                if (rol.toLowerCase() === roleobject["RoleName"].toLowerCase()) {
                  RolnotPrst = true
                  let StorageVolume = [];
                  let strVolume;
                  if (Array.isArray(roleobject.DAS.TableData)) {
                    roleobject.DAS.TableData.map((Volume) => {
                      StorageVolume.push(
                        Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
                      )
                    })
                    if (StorageVolume[2] !== undefined) {
                      strVolume = StorageVolume[0] + "    " + StorageVolume[1] + "    " + StorageVolume[2]
                    } else {
                      strVolume = StorageVolume[0] + "    " + StorageVolume[1]
                    }
                  } else {
                    strVolume = roleobject.DAS.TableData["VolumeName"] + " - " + roleobject.DAS.TableData["DiskQty"] + " X " + roleobject.DAS.TableData["Disk"]
                  }
                  roleobject["Memory"] = roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
                  if (Type === "BlueData") {
                    ComputeNodeSecondSolArray.push(
                      { "Role Name": roleobject["RoleName"] },
                      { "Server Name": roleobject.ServerName["@Qty"] + " X " + roleobject.ServerName["#text"] },
                      { "Processor": roleobject["ProcessorDetails"] },
                      { "Memory": roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                      // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                      { "Storage": strVolume }
                    );
                  } else {
                     let SerName = roleobject.ServerName["@Qty"] + " X " + roleobject.ServerName["#text"]
                      roleobj.Processor=roleobj.Processor.replace("1P"," ")
                      if (roleobject.ServerName["#text"] === "HP Moonshot System") {
                        SerName = roleobject.Processor
                      }
                    ComputeNodeSecondSolArray.push(
                      { "Role Name": roleobject["RoleName"] },
                      { "Server Name": SerName},
                      { "Processor": roleobject["ProcessorDetails"] },
                      { "Memory": roleobject["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                      // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                      { "Storage": strVolume });
                      if(roleobject.CPUPerf !== undefined && roleobject.StorageTP !== undefined && roleobject.StorageReadIO !== undefined && roleobject.StorageWriteIO !== undefined && roleobject.CPUPerfPrice !== undefined
                        && roleobject.RawStoragePrice !== undefined && roleobject.StoragePerfPrice !== undefined && roleobject.CPUPerfWatt !== undefined && roleobject.StoragePerfWatt !== undefined){
                      ComputeNodeSecondSolArray.push(
                      { "CPU Performance (SPECint)": roleobject.CPUPerf["#text"] },
                      { "Storage Throughput (MB/s)": roleobject.StorageTP["#text"] },
                      { "Storage Read IOPs (IOPs)": roleobject.StorageReadIO["#text"] },
                      { "Storage Write IOPs (IOPs)": roleobject.StorageWriteIO["#text"] },
                      { "CPU Perf/Price (SPECint/$1k)": roleobject.CPUPerfPrice["#text"] },
                      { "Raw Storage capacity/Price (TB/$1k)": roleobject.RawStoragePrice["#text"] },
                      { "Storage Perf/Price (MB/s per $1k)": roleobject.StoragePerfPrice["#text"] },
                      { "CPU Perf/Watt (SPECint/KW)": roleobject.CPUPerfWatt["#text"] },
                      { "Storage Perf/Watt (MB/s per KW)": roleobject.StoragePerfWatt["#text"] }
                    );
                        }
                        else{
                          ComputeNodeSecondSolArray.push(
                            { "CPU Performance (SPECint)": "NA" },
                            { "Storage Throughput (MB/s)": "NA" },
                            { "Storage Read IOPs (IOPs)": "NA" },
                            { "Storage Write IOPs (IOPs)": "NA" },
                            { "CPU Perf/Price (SPECint/$1k)": "NA" },
                            { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                            { "Storage Perf/Price (MB/s per $1k)": "NA" },
                            { "CPU Perf/Watt (SPECint/KW)": "NA" },
                            { "Storage Perf/Watt (MB/s per KW)": "NA" }
        
                          );
                        }
                  }
                }
              }
              if (!RolnotPrst) {
                if (Type === "BlueData") {
                  ComputeNodeSecondSolArray.push(
                    { "Role Name": "NA" },
                    { "Server Name": "NA" },
                    { "Processor": "NA" },
                    { "Memory": "NA" },
                    // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                    { "Storage": "NA" }
                  );
                } else {
                  ComputeNodeSecondSolArray.push(
                    { "Role Name": "NA" },
                    { "Server Name": "NA" },
                    { "Processor": "NA" },
                    { "Memory": "NA" },
                    // {"Storage":val.DAS.TableData["VolumeName"] + " - " +val.DAS.TableData["Disk"]}
                    { "Storage": "NA" },
                    { "CPU Performance (SPECint)": "NA" },
                    { "Storage Throughput (MB/s)": "NA" },
                    { "Storage Read IOPs (IOPs)": "NA" },
                    { "Storage Write IOPs (IOPs)": "NA" },
                    { "CPU Perf/Price (SPECint/$1k)": "NA" },
                    { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                    { "Storage Perf/Price (MB/s per $1k)": "NA" },
                    { "CPU Perf/Watt (SPECint/KW)": "NA" },
                    { "Storage Perf/Watt (MB/s per KW)": "NA" }
                  );
                }
              }
    
            });
            FirstSolRoles.filter((rol) => {
              if (Array.isArray(this.props.comparedata.CompareData.Solution[1].Roles.Role)) {
                this.props.comparedata.CompareData.Solution[1].Roles.Role.map(function (val) {
                  if (val["RoleName"] === "Compute hosts" || val["RoleName"] === "Compute Node") {
                    val["RoleName"] = "Compute Hosts"
                  } else if (val["RoleName"].toLowerCase() === "compute hosts with gpus" || val["RoleName"] === "GPU Node") {
                    val["RoleName"] = "Compute Hosts With GPUs"
                  } else if (val["RoleName"] === "Gateway Node") {
                    val["RoleName"] = "Gateway Host"
                  } else if (val["RoleName"] === "Controller Node") {
                    val["RoleName"] = "Controller Host"
                  } else if (val["RoleName"] === "Storage : HDFS and HDFS-ECC") {
                    val["RoleName"] = "Storage : HDFS"
                  }
                  if (FirstSolRoles.indexOf(val["RoleName"]) === -1) {
                    if (ExtraSeconSolroles.indexOf(val["RoleName"]) === -1) {
                      ExtraSeconSolroles.push(val["RoleName"])
                    }
                  }
                })
              } else {
                var roleobject = this.props.comparedata.CompareData.Solution[1].Roles.Role
                if (roleobject["RoleName"] === "Compute hosts" || roleobject["RoleName"] === "Compute Node") {
                  roleobject["RoleName"] = "Compute Hosts"
                } else if (roleobject["RoleName"].toLowerCase() === "compute hosts with gpus" || roleobject["RoleName"] === "GPU Node") {
                  roleobject["RoleName"] = "Compute Hosts With GPUs"
                } else if (roleobject["RoleName"] === "Gateway Node") {
                  roleobject["RoleName"] = "Gateway Host"
                } else if (roleobject["RoleName"] === "Controller Node") {
                  roleobject["RoleName"] = "Controller Host"
                }
                if (FirstSolRoles.indexOf(roleobject["RoleName"]) === -1) {
                  if (ExtraSeconSolroles.indexOf(roleobject["RoleName"]) === -1) {
                    ExtraSeconSolroles.push(roleobject["RoleName"])
                  }
                }
              }
            })
            ExtraSeconSolroles.filter((extrarol) => {
              if (Array.isArray(this.props.comparedata.CompareData.Solution[1].Roles.Role)) {
                this.props.comparedata.CompareData.Solution[1].Roles.Role.map(function (val) {
                  if (extrarol.toLowerCase() === val["RoleName"].toLowerCase()) {
                    let strVolume;
                    if (Array.isArray(val.DAS.TableData)) {
                      strVolume = this.populateStorageVolumes(val.DAS.TableData)
                    } else {
                      strVolume = val.DAS["VolumeName"] + " - " + val.DAS["DiskQty"] + " X " + val.DAS["Disk"]
                    }
                    val["Memory"] = val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
                    if (Type === "BlueData") {
                      ComputeNodeSecondSolArray.push(
                        { "Role Name": val["RoleName"] },
                        { "Server Name": val.ServerName["@Qty"] + " X " + val.ServerName["#text"] },
                        { "Processor": val["ProcessorDetails"] },
                        { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                        { "Storage": strVolume }
                      );
                    } else {
                      let SerName = val.ServerName["@Qty"] + " X " + val.ServerName["#text"]
                       val.Processor=val.Processor.replace("1P"," ")
                      if (val.ServerName["#text"] === "HP Moonshot System") {
                        SerName = val.Processor
                      }
                      ComputeNodeSecondSolArray.push(
                        { "Role Name": val["RoleName"] },
                        { "Server Name": SerName },
                        { "Processor": val["ProcessorDetails"] },
                        { "Memory": val["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                        { "Storage": strVolume });
                        if(val.CPUPerf !== undefined && val.StorageTP !== undefined && val.StorageReadIO !== undefined && val.StorageWriteIO !== undefined && val.CPUPerfPrice !== undefined
                          && val.RawStoragePrice !== undefined && val.StoragePerfPrice !== undefined && val.CPUPerfWatt !== undefined && val.StoragePerfWatt !== undefined){
                        ComputeNodeSecondSolArray.push(
                            { "CPU Performance (SPECint)": val.CPUPerf["#text"] },
                        { "Storage Throughput (MB/s)": val.StorageTP["#text"] },
                        { "Storage Read IOPs (IOPs)": val.StorageReadIO["#text"] },
                        { "Storage Write IOPs (IOPs)": val.StorageWriteIO["#text"] },
                        { "CPU Perf/Price (SPECint/$1k)": val.CPUPerfPrice["#text"] },
                        { "Raw Storage capacity/Price (TB/$1k)": val.RawStoragePrice["#text"] },
                        { "Storage Perf/Price (MB/s per $1k)": val.StoragePerfPrice["#text"] },
                        { "CPU Perf/Watt (SPECint/KW)": val.CPUPerfWatt["#text"] },
                        { "Storage Perf/Watt (MB/s per KW)": val.StoragePerfWatt["#text"] }
                      );
                        }
                        else{
                          ComputeNodeSecondSolArray.push(
                            { "CPU Performance (SPECint)": "NA" },
                            { "Storage Throughput (MB/s)": "NA" },
                            { "Storage Read IOPs (IOPs)": "NA" },
                            { "Storage Write IOPs (IOPs)": "NA" },
                            { "CPU Perf/Price (SPECint/$1k)": "NA" },
                            { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                            { "Storage Perf/Price (MB/s per $1k)": "NA" },
                            { "CPU Perf/Watt (SPECint/KW)": "NA" },
                            { "Storage Perf/Watt (MB/s per KW)": "NA" }
        
                          );
                        }
                    }
                  }
                }.bind(this))
              } else {
                var roleobj = this.props.comparedata.CompareData.Solution[1].Roles.Role
                if (extrarol.toLowerCase() === roleobj["RoleName"].toLowerCase()) {
                  let StorageVolume = [];
                  let strVolume;
                  if (Array.isArray(roleobj.DAS.TableData)) {
                    roleobj.DAS.TableData.map((Volume) => {
                      StorageVolume.push(
                        Volume["VolumeName"] + " - " + Volume["DiskQty"] + " X " + Volume["Disk"]
                      )
                    })
                    if (StorageVolume[2] !== undefined) {
                      strVolume = StorageVolume[0] + "    " + StorageVolume[1] + "    " + StorageVolume[2]
                    } else {
                      strVolume = StorageVolume[0] + "    " + StorageVolume[1]
                    }
                  } else {
                    strVolume = roleobj.DAS["VolumeName"] + " - " + roleobj.DAS["DiskQty"] + " X " + roleobj.DAS["Disk"]
                  }
                  roleobj["Memory"] = roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '');
                  if (Type === "BlueData") {
                    ComputeNodeSecondSolArray.push(
                      { "Role Name": roleobj["RoleName"] },
                      { "Server Name": roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"] },
                      { "Processor": roleobj["ProcessorDetails"] },
                      { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                      { "Storage": strVolume }
                    );
                  }
                  else {
                     let SerName = roleobj.ServerName["@Qty"] + " X " + roleobj.ServerName["#text"]
                      roleobj.Processor=roleobj.Processor.replace("1P"," ")
                      if (roleobj.ServerName["#text"] === "HP Moonshot System") {
                        SerName = roleobj.Processor
                      }
                    ComputeNodeSecondSolArray.push(
                      { "Role Name": roleobj["RoleName"] },
                      { "Server Name": SerName },
                      { "Processor": roleobj["ProcessorDetails"] },
                      { "Memory": roleobj["Memory"].replace(/[^a-z0-9 ,.?!]/ig, '') },
                      { "Storage": strVolume });
                      if(roleobj.CPUPerf !== undefined && roleobj.StorageTP !== undefined && roleobj.StorageReadIO !== undefined && roleobj.StorageWriteIO !== undefined && roleobj.CPUPerfPrice !== undefined
                        && roleobj.RawStoragePrice !== undefined && roleobj.StoragePerfPrice !== undefined && roleobj.CPUPerfWatt !== undefined && roleobj.StoragePerfWatt !== undefined){
                      ComputeNodeSecondSolArray.push( 
                      { "CPU Performance (SPECint)": roleobj.CPUPerf["#text"] },
                      { "Storage Throughput (MB/s)": roleobj.StorageTP["#text"] },
                      { "Storage Read IOPs (IOPs)": roleobj.StorageReadIO["#text"] },
                      { "Storage Write IOPs (IOPs)": roleobj.StorageWriteIO["#text"] },
                      { "CPU Perf/Price (SPECint/$1k)": roleobj.CPUPerfPrice["#text"] },
                      { "Raw Storage capacity/Price (TB/$1k)": roleobj.RawStoragePrice["#text"] },
                      { "Storage Perf/Price (MB/s per $1k)": roleobj.StoragePerfPrice["#text"] },
                      { "CPU Perf/Watt (SPECint/KW)": roleobj.CPUPerfWatt["#text"] },
                      { "Storage Perf/Watt (MB/s per KW)": roleobj.StoragePerfWatt["#text"] }
                    );
                        }
                        else{
                          ComputeNodeSecondSolArray.push(
                            { "CPU Performance (SPECint)": "NA" },
                            { "Storage Throughput (MB/s)": "NA" },
                            { "Storage Read IOPs (IOPs)": "NA" },
                            { "Storage Write IOPs (IOPs)": "NA" },
                            { "CPU Perf/Price (SPECint/$1k)": "NA" },
                            { "Raw Storage capacity/Price (TB/$1k)": "NA" },
                            { "Storage Perf/Price (MB/s per $1k)": "NA" },
                            { "CPU Perf/Watt (SPECint/KW)": "NA" },
                            { "Storage Perf/Watt (MB/s per KW)": "NA" }
        
                          );
                        }
                  }
                }
              }
            })
            var x = ComputeNodeArray.length;
            var y = ComputeNodeSecondSolArray.length;
    
            if (x > y) {
              totalNumOfRows.length = x;
            } else {
              totalNumOfRows.length = y;
            }
            var RoleItems = []
            if (Type === "BlueData") {
              RoleItems = ["Role Name", "Server Name", "Processor", "Memory", "Storage"];
            } else {
              RoleItems = ["Role Name", "Server Name", "Processor", "Memory", "Storage", "CPU Performance (SPECint)", "Storage Throughput (MB/s)", "Storage Read IOPs (IOPs)", "Storage Write IOPs (IOPs)", "CPU Perf/Price (SPECint/$1k)", "Raw Storage capacity/Price (TB/$1k)", "Storage Perf/Price (MB/s per $1k)", "CPU Perf/Watt (SPECint/KW)", "Storage Perf/Watt (MB/s per KW)"];
            }
    
            var countRole = 0;
            for (var i = 0; i < totalNumOfRows.length; i++) {
              var ComputeValue;
              var ComputeValueSecond;
              if (i >= ComputeNodeSecondSolArray.length) {
                ComputeValueSecond = "NA";
              } else {
                ComputeValueSecond = ComputeNodeSecondSolArray[i][RoleItems[countRole]];
              }
              if (i >= ComputeNodeArray.length) {
                ComputeValue = "NA";
              } else {
                ComputeValue = ComputeNodeArray[i][RoleItems[countRole]];
              }
              let textspace = ''
              let textspacetwo = ''
              if (ComputeValueSecond === "NA") {
                textspace = 'center'
              }
              if (ComputeValue === "NA") {
                textspacetwo = 'center'
              }
              var backgrdclr = '#fff'
              if (ComputeValueSecond !== ComputeValue && ComputeValueSecond !== 'NA' && ComputeValue !== 'NA') {
                backgrdclr = '#ffd144'
              }
              else{
                backgrdclr = '#fff'
              }
              RolesList.push(<TableRow>
                <td>{RoleItems[countRole]}</td>
                <td style={{ textAlign: textspace, backgroundColor: backgrdclr }}>{ComputeValueSecond}</td>
                <td style={{ textAlign: textspacetwo, backgroundColor: backgrdclr }}>{ComputeValue}</td>
    
              </TableRow>
              );
              data.push({
                "role": RoleItems[countRole],
                "computevaluesecond": ComputeValueSecond,
                "computevalue": ComputeValue
              })
              countRole++;
              if (Type === "BlueData") {
                if (countRole == 5) {
                  countRole = 0;
                }
              } else {
                if (countRole == 14) {
                  countRole = 0;
                }
              }
            }
            var Currencyone = ''
            var Currencytwo = ''
            if (this.props.comparedata.CompareData['@Currency'] === 'UD') {
              Currencyone = '$ ' + this.props.comparedata.CompareData.Solution[1].SolPrice
              Currencytwo = '$ ' + this.props.comparedata.CompareData.Solution[0].SolPrice
    
            } else {
              Currencyone = this.props.comparedata.CompareData['@Currency'] + " " + this.props.comparedata.CompareData.Solution[1].SolPrice
              Currencytwo = this.props.comparedata.CompareData['@Currency'] + " " + this.props.comparedata.CompareData.Solution[0].SolPrice
            }
          }
          else if (this.props.comparedata !== null && this.props.comparedata !== undefined && !this.props.isLoading && !this.state.CloseErrorLayer && this.props.comparedata.CompareData !== null && this.props.comparedata.CompareData === 'File Mismatch') {
            this.state.CloseErrorLayer = false
            compare = <Layer closer={false} overlayClose={true} >
              <Box margin="none" pad="none" size='medium'>
                <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
                  <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                    <WarningIcon colorIndex='critical' size='small' />
                    <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
                  </Box>
                  <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.handleCloseError.bind(this)} >
                    <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
                  </Box>
                </Box>
                <Box direction="row" margin="small" pad={{ between: 'small' }} >
                  <Paragraph margin="small" >{'Current solution is configured with different platform. Kindly select the solution with same platform to compare'}</Paragraph>
                </Box>
              </Box>
            </Layer>
          }
          else if (this.props.comparedata !== null && this.props.comparedata !== undefined && !this.props.isLoading && !this.state.CloseErrorLayer && this.props.comparedata.CompareData !== null && this.props.comparedata.CompareData === 'Different Pricing Region') {
            this.state.CloseErrorLayer = false
            compare = <Layer closer={false} overlayClose={true} >
              <Box margin="none" pad="none" size='medium'>
                <Box direction="row" colorIndex='neutral-1' margin="none" pad="small" separator="bottom">
                  <Box direction="row" margin="none" pad={{ between: 'small' }} align='start' style={{ width: '96%' }}>
                    <WarningIcon colorIndex='critical' size='small' />
                    <Heading tag="h4" strong={false} style={{ marginBottom: '0px' }}>Error</Heading>
                  </Box>
                  <Box direction="row" margin="none" pad="none" align='start' alignContent="start" onClick={this.handleCloseError.bind(this)} >
                    <CloseIcon size='small' colorIndex='light-2' className="CloseIconStyle" />
                  </Box>
                </Box>
                <Box direction="row" margin="small" pad={{ between: 'small' }} >
                  <Paragraph margin="small" >{'Current solution is configured with different Price Region. Kindly select the solution with same Price Region to compare'}</Paragraph>
                </Box>
              </Box>
            </Layer>
          }
        }
      let StyleTable = "CompareTable"
      if (Type === "BlueData") {
        StyleTable = "CompareTable"
      }
      else {
        StyleTable = "CompareTableBig"
      }
      let backgrdclrtotal = '#fff'
      if (Currencyone !== Currencytwo && Currencyone !== 'NA' && Currencytwo !== 'NA') {
        backgrdclrtotal = '#ffd144'
        
      }
      else{
        backgrdclrtotal = '#fff'
      }
        // var link = serviceUrl+said+"/ExportCompareSolution?sessionId="+this.props.activeSession.id;
        SolutionAlternativeTabsContent = '';        
        SolutionAlternativeTabsContent = <Box margin="small"   className="CompareSolutionTable">
          <Box pad={{"between" : "small"}}>
            <Box direction = "row" pad={{"between" : "small"}} justify="center">
               <Box direction='row'>            
              <Select name="compareSolution1" value={compareSolution1value} options={compareSolution1Options} onChange={(e)=>{this.compareSolution12Change(e)}} />
              <Select name="compareSolution2" value={compareSolution2value} options={compareSolution2Options} onChange={(e)=>{this.compareSolution12Change(e)}} />
              </Box>
              <Button  primary={true} label='Compare' onClick={this.compareSolnMethod} />
            </Box>
            <Box style={{ marginLeft:'44%' }}></Box>
          </Box>
  
          {this.state.ComapareSolState && Currencyone !== undefined ?
            <Box className={StyleTable}>
              <Table>
                <thead>
                  <tr>
                    <th style={{ width: '20%' }}> Details</th>
                    <th>{this.props.activeSession.EPAArray.length > 0 && this.props.activeSession.selectedTitles!==undefined ?  this.props.activeSession.selectedTitles.compareSolution1value : 
                        this.props.activeSession.alias}</th>
                    <th>{this.props.activeSession.EPAArray.length > 0 && this.props.activeSession.selectedTitles!==undefined ?this.props.activeSession.selectedTitles.compareSolution2value:this.props.activeSession.alias}</th>
                  </tr>
                </thead>
                <tbody>
                  <TableRow>
                    <td>Rack</td>
                    {CombineRackSecond}
                  </TableRow>
                  {RolesList}
                </tbody>
                <tfoot>
                  <tr>
                    <th> Total</th>
                    <th style={{ textAlign: 'center', backgroundColor: backgrdclrtotal }}>{Currencyone}</th>
                    <th style={{ textAlign: 'center', backgroundColor: backgrdclrtotal }}>{Currencytwo}</th>
                  </tr>
                </tfoot>
              </Table>
              <Button label='Export to Excel' primary={true} onClick={this.onExport.bind(this)} style={{ height: '40px', marginTop: '20px', width: '27%' }} />
            </Box>
            : ''}
        </Box>
        
    }
      var Loading = '';
      if(this.props.sessions.isLoading){
         Loading = <Layer style={{ zIndex: '500 !important' }}>
         <Box direction='row' style={{ padding: '40px', backgroundColor: "#425563" }} size='medium' pad={{ 'between': 'small' }}>
             <Spinning className="Spinning" size='small' />
             <Heading tag='h5' margin='none' style={{ color: "#fff" }}>{"Loading Data"}</Heading>
         </Box>
     </Layer>
      }
      
    return (
      this.props.sessions.isLoading && this.props.activeSession==='' && this.props.activeSession.EPAArray!==undefined?
      <Box>
      {Loading}
      </Box>:
      <Box style={{ height: '98%' }}>
      <Box colorIndex="light-2" direction="row" align='start' pad='none' separator="left"
      style={{
          height: '98%', width: '100%', overflowY: 'auto',
          position: 'absolute', right: '0px', top: '0px', zIndex: 3
      }}>

          <Animate enter={{ "animation": "slide-left", "duration": 200, "delay": 0 }}
              leave={{ "animation": "slide-left", "duration": 200, "delay": 0 }}
              keep={true} style={{ width: '100%' }} >
              <Box style={{ width: '100%' }}>
                  <Box direction='row' style={{ backgroundColor: '#28ab8c' }} >
                      <Box style={{ width: "95%", padding: '5px', color: '#fff' }} >
                          <Heading tag="h4" align="center" margin="none" position='fixed' width='100%' strong={true} >Compare Solution</Heading>
                      </Box>
                      {this.props.isFromExternalApp ? 
                          <Button id="backToSSETyes" primary={false} plain={true} style={{position:'absolute',right:'0',color:'white'}}  /* icon={<Revert size="small" colorIndex='accent-3' />} */ label='Back' onClick={()=>{this.redirectUrl()}} className="ReverseSavewrkloadbtn" />
                          :
                          <Box id="informationiconbox" style={{ marginTop: "5px" }} direction="row" margin="none" pad="none" justify="end" onClick={() => this.props.onClose()} >
                              <CloseIcon size='small' />
                          </Box>
                      }
                  </Box>
                  <Box>
                  {SolutionAlternativeTabsContent}
                  </Box>
                  
              </Box>
          </Animate>
      </Box>
  </Box>
       
      )
  }
}

const mapStateToProps = (state) => {
  let workloadTemp ='';
  if(state.sizerWorkload.workload!==undefined && Object.keys(state.sizerWorkload.workload).length>0){
    workloadTemp = state.sizerWorkload.workload;
  }
  else if(state.sessions.activeSession!==undefined && state.sessions.activeSession.workload!==undefined){
    workloadTemp = state.sessions.activeSession.workload;
  }
  return {
    allSessions: state.sessions.sessions,
    activeSession: state.sessions.activeSession,
    DefaultInputs: state.sessions.sessionDefaults.inputs,
    OverrideSolMsg: state.sessions.overrideSolMsg,
    toastNotification: state.sessions.notificationMsg,
    UserID: state.auth.userData.email,
    //workload: state.sizerWorkload.workload,
    workload: workloadTemp,
    sessions: state.sessions,
    CompareMetricsData: state.sessions.activeSession.CompareMetricsData,
    //comparedata: state.sessions.CompareData,
    comparedata: state.sessions.activeSession.CompareData,
    networkError: state.sessions.networkError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    OnComparedata: (value) => {
        dispatch(comparedata(value));
      },
      onFetchCompareSolution: (obj) => {
        dispatch(fetchCompareSolution(obj));
      },
      getSSETData: (userData) => { dispatch(loadSessionfromSSET(userData)) },
      onNewSession: (workload) => {
        dispatch({ type: 'UPDATE_SIZER_WORKLOAD', payload: workload })
    },
    onExportCompaeSolution: (text) => {
      dispatch(exportCompareSolution(text));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CompareSol);



// WEBPACK FOOTER //
// ./src/SizingEngineUI/SizingEngineCommonScreens/CompareSol.js